import { apiGET, apiPOST } from '../utils/adapterFunctions'

export const getReferToken = async () => {
  return await apiPOST('/refer-friend/token/sportsbook')
}

export const getRemaining = async () => {
  return await apiGET('/refer-friend/remaining')
}

export const getCurrentStats = async () => {
  return await apiGET('/refer-friend/current')
}

export const getHistoryStats = async ({ start, end }) => {
  return await apiGET('/refer-friend/history', {
    params: {
      start,
      end,
    },
  })
}